import styled from 'styled-components';

import { LimitedTimer } from '../../../V1/components/LimitedTimer';

import { onboardingPaywallSectionTimerTime } from './constants';

const SectionTimerStyles = styled.section`
  margin: 16px auto 48px;
  max-width: 340px;
  width: 100%;
  padding: 0 16px;

  @media screen and (min-width: 576px) {
    max-width: 432px;
  }
`;

export const SectionTimer: React.FC = () => {
  return (
    <SectionTimerStyles>
      <LimitedTimer
        timeToExpire={onboardingPaywallSectionTimerTime * 1000 * 60}
      />
    </SectionTimerStyles>
  );
};
